<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Send SMS</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container class="pt-5 w-50" style="min-width: max-content; max-width: 600px;">
			<b-card>
				<b-form>
					<b-row>
						<b-col xl="3" lg="3" sm="3">
							<p class="mt-3">
								<span class="h3">To</span>
								<span class="text-danger">*</span>
							</p>
						</b-col>
						<b-col xl="9" lg="9" sm="9">
							<b-form-group label-for="input-1">
								<b-form-input
									type="number"
									:state="receiverValidation"
									v-model="sendSMSForm.receiver"
									required
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="3" lg="3" sm="3">
							<p class="mt-3">
								<span class="h3">From</span>
								<span class="text-danger">*</span>
							</p>
						</b-col>
						<b-col xl="9" lg="9" sm="9">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									type="number"
									:state="senderValidation"
									v-model="sendSMSForm.sender"
									required
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="12">
							<p class="mt-3">
								<span class="h3">SMS</span>
								<span class="text-danger">*</span>
							</p>
							<b-form-textarea
								id="sms-content"
								v-model="sendSMSForm.content"
								:state="smsValidation"
								placeholder="Enter SMS content to send"
								rows="3"
								:formatter="formatLength"
								required
							></b-form-textarea>
							<p class="text-xs">{{ this.sendSMSForm.content.length }}/160</p>
						</b-col>
					</b-row>
					<hr />
					<div class="mt-3 d-flex justify-content-between">
						<base-button type="danger" title="Clear" v-on:click="clearForm()"> Clear </base-button>
						<base-button
							type="primary"
							title="Send"
							:disabled="validation"
							v-on:click="sendSMSSubmit"
							:loading="submitLoading"
						>
							Send
						</base-button>
					</div>
				</b-form>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import initService from "../../../common/api-services/init-service";
import searchDashboardService from "../../../common/api-services/search-dashboard-service";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

export default {
	name: "SendSms",
	components: {RouteBreadCrumb},
	mounted() {
		document.title = "Troubleshooting - Send SMS";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			sendSMSForm: {
				receiver: "",
				sender: "",
				content: "",
			},
			contentLength: 160,
			submitLoading: false,
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		validation() {
			let validated = false;
			if (this.senderValidation && this.receiverValidation && this.smsValidation) {
				validated = true;
			}
			return !validated;
		},

		smsValidation() {
			return this.sendSMSForm.content.length > 0 && this.sendSMSForm.content.length <= 160
		},

		senderValidation() {
			return String(this.sendSMSForm.sender).length === 11;
		},

		receiverValidation() {
			return String(this.sendSMSForm.receiver).length === 11;
		},
	},
	methods: {
		formatLength(event) {
			return String(event).substring(0, 160);
		},

		async sendSMSSubmit(event) {
			event.preventDefault();
			this.submitLoading = true;
			let {sender, receiver, content} = this.sendSMSForm;
			// console.log(sender, receiver, content);
			await searchDashboardService.sendSMS(sender, receiver, content).then(res => {
				// console.log("sendSMSSubmit", res);
				if (
					(res && String(res).toLowerCase().includes("error")) ||
					String(res).toLowerCase().includes("fail") ||
					String(res).toLowerCase().includes("null")
				) {
                    this.submitLoading = false;
					this.$toast.error(res);
					return;
				}
				this.sendSMSForm = {
					receiver: "",
					sender: "",
					content: "",
				};
				this.submitLoading = false;
				this.$toast.success(res.response);
			})
            .catch(error => {
                console.log(error);
                this.submitLoading = false;
                this.$toast.error(error);
            });
		},
		clearForm() {
			this.sendSMSForm = {
				receiver: "",
				sender: "",
				content: "",
			};
		},
	},
};
</script>
